import * as React from 'react';
import { Alert, FormGroup } from 'reactstrap';
import { Select } from '../../../components/ui/Select';
import { GetAllProjects, IProject } from './utils';

interface IProjectSelectProps {
  value: string
  onChange: (newValue?: string) => void
  label?: string
  required?: boolean
  readOnly?: boolean
}

interface IProjectSelectState {
  projects: IProject[]
}

export class ProjectSelect extends React.Component<IProjectSelectProps, IProjectSelectState> {
  state: IProjectSelectState = {
    projects: [],
  }

  componentWillMount() {
    this.loadProjects()
  }

  loadProjects(props = this.props) {
    GetAllProjects().then((projects) => {
      this.setState({ projects })
    })
  }

  render() {
    const { value, onChange, required, readOnly } = this.props
    const { projects } = this.state
    const label = 'Project'

    return (
      <FormGroup>
        <label>{label}</label>

        <Select<IProject, 'id'>
          label={label}
          options={projects}
          value={value}
          readOnly={readOnly}
          required={required}
          loading={projects.length <= 0}
          valueKey="id"
          labelKey="display"
          onChange={(newValue) => onChange(newValue)} />
      </FormGroup>
    )
  }
}
